import { c as _c } from "react/compiler-runtime";
import { useMeasureOptions } from '@/hooks/store/use-measure-options-store';
import { useMemo } from 'react';
import { useAnalyzedKey } from '@/hooks/keyboard/use-analyzed-key';
import type { OptionalNumber } from '@/lib/piano/touch-design/measured-key.requirements';
export const useKeyMeasurementInconsistency = keyNumber => {
  const $ = _c(11);
  const {
    useManualSWRMeasurements
  } = useMeasureOptions();
  const {
    analyzedKey
  } = useAnalyzedKey(keyNumber);
  const allowedDifference = 0.05;
  analyzedKey?.measuredStrikeWeightRatio;
  const measuredStrikeWeightRatio = analyzedKey?.measuredStrikeWeightRatio ?? null;
  let t0;
  if ($[0] !== analyzedKey?.computedStrikeWeightRatio) {
    t0 = () => analyzedKey?.computedStrikeWeightRatio ?? null;
    $[0] = analyzedKey?.computedStrikeWeightRatio;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  analyzedKey?.computedStrikeWeightRatio;
  let t1;
  if ($[2] !== t0) {
    t1 = t0();
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const computedStrikeWeightRatio = t1;
  let t2;
  bb0: {
    if (!useManualSWRMeasurements || !measuredStrikeWeightRatio || !computedStrikeWeightRatio) {
      t2 = false;
      break bb0;
    }
    let t3;
    if ($[4] !== computedStrikeWeightRatio || $[5] !== measuredStrikeWeightRatio) {
      t3 = Math.abs(computedStrikeWeightRatio - measuredStrikeWeightRatio).toFixed(2);
      $[4] = computedStrikeWeightRatio;
      $[5] = measuredStrikeWeightRatio;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const differenceBetweenComputedAndMeasuredValue = parseFloat(t3);
    t2 = differenceBetweenComputedAndMeasuredValue > 0.05;
  }
  const isKeyMeasurementInconsistent = t2;
  let t3;
  if ($[7] !== computedStrikeWeightRatio || $[8] !== isKeyMeasurementInconsistent || $[9] !== measuredStrikeWeightRatio) {
    t3 = {
      allowedDifference: 0.05,
      computedStrikeWeightRatio,
      isKeyMeasurementInconsistent,
      measuredStrikeWeightRatio
    };
    $[7] = computedStrikeWeightRatio;
    $[8] = isKeyMeasurementInconsistent;
    $[9] = measuredStrikeWeightRatio;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};